import React, { useContext } from 'react';

export const FeatureContext = React.createContext<string[]>([]);

FeatureContext.displayName = 'FeatureContext';

export const withFeatures = <P extends Record<string, unknown>>(
  Component: React.ComponentType<P>,
): ((props: P) => JSX.Element) => {
  return (props: P) => {
    return (
      <FeatureContext.Consumer>
        {(features) => <Component {...props} features={features} />}
      </FeatureContext.Consumer>
    );
  };
};

export const useFeatures = (): string[] => useContext(FeatureContext);

export default FeatureContext;
